module.exports = __webpack_public_path__ + "public/media/developer-vector2.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-vector2.png
// module id = ./images/services/developer-vector2.png
// module chunks = 0